import Vue from 'vue';

export async function crearPreguntaValoracion(accessToken, datos) {
  const response = await Vue.axios.post('/valoracion-preguntas', datos, {
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + accessToken,
    },
  });
  return response.data.data;
}

export async function editarPreguntaValoracion(accessToken, preguntaId, datos) {
  const response = await Vue.axios.put(`/valoracion-preguntas/${preguntaId}`, datos, {
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + accessToken,
    },
  });
  return response.data.data;
}

export async function eliminarPreguntaValoracion(accessToken, preguntaId) {
  await Vue.axios.delete(`/valoracion-preguntas/${preguntaId}`, {
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + accessToken,
    },
  });
}

export async function actualizarEstadoPreguntaValoracion(accessToken, preguntaId, activa) {
  const response = await Vue.axios.patch(`/valoracion-preguntas/${preguntaId}/estado`, { activa }, {
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + accessToken,
    },
  });
  return response.data.data;
}

export async function listarPreguntasValoracion(accessToken) {
  const response = await Vue.axios.get('/valoracion-preguntas', {
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + accessToken,
    },
  });
  return response.data.data;
}

export async function obtenerValoracionesProveedor(accessToken, proveedorId) {
  const response = await Vue.axios.get(`/proveedores/${proveedorId}/valoraciones`, {
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + accessToken,
    },
  });

  return response.data.data;
}

export async function obtenerValoracionesReserva(accessToken, reservaId) {
  const response = await Vue.axios.get(`/reservas/${reservaId}/valoraciones`, {
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + accessToken,
    },
  });

  return response.data.data;
}

export async function obtenerResumenValoraciones(accessToken) {
  const response = await Vue.axios.get('/valoraciones/resumen', {
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + accessToken,
    },
  });

  return response.data.data;
}
